/**
 * @generated SignedSource<<167cca2948f93434bdbe853f911245d5>>
 * @relayHash 8a771500e78a507661fb98bcbbb37ab3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a771500e78a507661fb98bcbbb37ab3

import { ConcreteRequest } from 'relay-runtime';
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type preventionProgramsSectionDeQuery$variables = {
  search: string;
};
export type preventionProgramsSectionDeQuery$data = {
  readonly preventionPrograms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string;
        readonly name: {
          readonly de: string;
          readonly en: string;
          readonly fr: string;
          readonly it: string;
        };
        readonly specialty: ServiceSpecialty;
      };
    }> | null;
  } | null;
};
export type preventionProgramsSectionDeQuery = {
  response: preventionProgramsSectionDeQuery$data;
  variables: preventionProgramsSectionDeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": "preventionPrograms",
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "de_PreventionProgramSummaryConnection",
    "kind": "LinkedField",
    "name": "de_preventionPrograms",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_PreventionProgramSummaryEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_PreventionProgramSummary",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalizedName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "en",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "de",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fr",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "it",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialty",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "preventionProgramsSectionDeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "preventionProgramsSectionDeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "8a771500e78a507661fb98bcbbb37ab3",
    "metadata": {},
    "name": "preventionProgramsSectionDeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "389e3348675a7c936f4971419d63a9e7";

export default node;
